import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import OptionModal from '../../../../../components/modals/option-modal';
import { Link as RouterLink } from 'react-router-dom';
import { route } from '../../../../../services/utils';
import {
  CROP_FIELD_CREATE,
  CROP_FIELD_IMPORT,
  CROP_FIELD_CREATE_LAD,
} from '../../../../../router/routes';
import { useParams } from 'react-router';
import indexCss from './create-new-field-modal.module.css';
import { ButtonStyling } from '../../../../../components/form/elements/button';
import drawIcon from './icons/draw.svg';
import chooseIcon from './icons/choose.svg';
import importIcon from './icons/import.svg';

export default function CreateNewFieldModal({
  setShowModal,
}: {
  setShowModal: Dispatch<SetStateAction<boolean>>;
}) {
  const transKeyPrefix = 'pages.crop.fields_and_works.fields.';
  const { t } = useTranslation();
  const { farmId, season } = useParams<{ farmId: string; season: string }>();

  return (
    <OptionModal
      title={undefined}
      className={indexCss['modal-container']}
      content={
        <div className={indexCss['container']}>
          <RouterLink
            to={route(CROP_FIELD_CREATE, {
              farmId: farmId,
              season: season,
            })}
            className={indexCss['button-container']}
          >
            <img className={indexCss['icon']} src={drawIcon} alt="" />
            <div className={indexCss['button-text-container']}>
              <label className={indexCss['main-text']}>
                {t(transKeyPrefix + 'draw')}
              </label>
              <label className={indexCss['second-text']}>
                {t(transKeyPrefix + 'draw_desc')}
              </label>
            </div>
          </RouterLink>
          <div className={indexCss['divider']} />
          <RouterLink
            to={route(CROP_FIELD_CREATE_LAD, {
              farmId: farmId,
              season: season,
            })}
            className={indexCss['button-container']}
          >
            <img className={indexCss['icon']} src={chooseIcon} alt="" />
            <div className={indexCss['button-text-container']}>
              <label className={indexCss['main-text']}>
                {t(transKeyPrefix + 'choose_on_map')}
              </label>
              <label className={indexCss['second-text']}>
                {t(transKeyPrefix + 'choose_on_map_desc')}
              </label>
            </div>
          </RouterLink>
          <div className={indexCss['divider']} />
          <RouterLink
            to={route(CROP_FIELD_IMPORT, {
              farmId: farmId,
              season: season,
            })}
            className={indexCss['button-container']}
          >
            <img className={indexCss['icon']} src={importIcon} alt="" />
            <div className={indexCss['button-text-container']}>
              <label className={indexCss['main-text']}>
                {t(transKeyPrefix + 'import_from_lad')}
              </label>
              <label className={indexCss['second-text']}>
                {t(transKeyPrefix + 'import_from_lad_desc')}
              </label>
            </div>
          </RouterLink>
        </div>
      }
      buttons={[{ title: t('cancel'), name: 'no', value: false }]}
      onChoice={() => {
        setShowModal(false);
      }}
      onClose={() => setShowModal(false)}
      buttonStyle={ButtonStyling.cancel}
    />
  );
}
